import http from '@services/http';
import * as xformAdmin from './transformers';
import { Projects } from './interfaces';

export function fetchProjectDetails(data: Projects.FetchProjectDetails.Request): Promise<Projects.FetchProjectDetails.Response> {
  return http.get(`/admin/projects/${data.projectId}/details`)
    .then((data: Projects.FetchProjectDetails.Response<string>) => xformAdmin.projects.transformProjectDetails(data));
}